import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = localStorage.getItem('token');

    if (!token) {
      console.warn("🔒 No token found. Redirecting.");
      this.router.navigate(['/login']);
      return false;
    }

    try {
      const decoded: any = jwtDecode(token);
      const userRole = decoded.role;
      const expiration = decoded.exp;
      const expectedRoles = route.data['roles'] as string[];

      if (expiration && Date.now() >= expiration * 1000) {
        console.warn("⏰ Token expired.");
        this.router.navigate(['/login']);
        return false;
      }

      if (expectedRoles && !expectedRoles.includes(userRole)) {
        console.warn("⛔ Unauthorized role:", userRole);
        this.router.navigate(['/login']);
        return false;
      }

      return true;
    } catch (err) {
      console.error("❌ Invalid token:", err);
      this.router.navigate(['/login']);
      return false;
    }
  }
}
